/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { marketingPreferencesGetResponseSchema } from './marketingPreferencesGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getMarketingPreferences200Schema = z.lazy(() => marketingPreferencesGetResponseSchema);

/**
 * @description 505 response
 */
export const getMarketingPreferences505Schema = z.any();

export const getMarketingPreferencesQueryResponseSchema = z.lazy(() => getMarketingPreferences200Schema);
